// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"231":"feed","263":"widget","791":"video"}[chunkId] + "." + {"231":"9f60d3ce6103c35e9451","263":"bc13b8300c1887bf2604","791":"dc794c96e3b21f57801a"}[chunkId] + ".js";
};